var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-maps-header pt-1"},[_c('h1',{staticClass:"page-title"},[_c('span',[_vm._v("DIREKTKONTAKT ZUR NIEDERLASSUNG "+_vm._s(_vm.header))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }